import { Tag } from 'antd';
import styled from 'styled-components';

export const StyledTag = styled(Tag)`
    background-color: var(--gray-3);
    border-color: var(--gray-4);
    color: var(--gray-9);
    cursor: pointer;
    user-select: none;

    font-size: 12px;
    line-height: 20px;

    .anticon {
        color: var(--gray-7);
        margin-left: 4px;
    }

    &:hover {
        background-color: var(--brand-1);
        border-color: var(--brand-7);
    }
`;
